import { AppBar, Toolbar, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useUser } from '../hooks/User';
import { userService } from '../services/userService';

const Navbar = () => {
  const { user, logout } = useUser();

  return (
    <AppBar position="static">
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <div>
          <Button 
            component={Link} 
            to="/" 
            color="inherit"
            sx={{ mr: 2 }}
          >
            Home
          </Button>


          {user ? (
            <>
              <Button 
                component={Link} 
                to="/jobs" 
                color="inherit"
                sx={{ mr: 2 }}
              >

                Jobs
              </Button> 
            </>
          ) : (
            <></>
          ) }


          {user ?  (
            <Button 
              component={Link} 
              to="/resumes" 
              color="inherit"
              sx={{ mr: 2 }}
            >
              Resumes
            </Button>
          ) : (
            <></>
          ) }
          {user ? (
            <Button 
              component={Link} 
              to="/profile" 
              color="inherit"
              sx={{ mr: 2 }}
            >
              Profile
            </Button>
          ) : (
            <></>
          ) }
        </div>
        {user ? (
          <Button 
            onClick={logout}
            color="inherit"
          >
            Logout
          </Button>
        ) : (
          <></>
        ) }
        {!user && (
          <Button 
            component={Link} 
            to={userService.googleLoginRoute}
            color="inherit"
            sx={{ mr: 2 }}
          >
            Login
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
